import NotificationsSettingsPage from "components/pages/NotificationsSettingsPage";

export default function CaptureNotifiSettings(props) {
    return <NotificationsSettingsPage /> 
}